<glxy-nav #nav appName="observatory">
  <glxy-nav-panel #navPanel>
    <!-- Menu Content -->
    <ng-container *ngTemplateOutlet="menuContent" />
  </glxy-nav-panel>

  <!-- Page Content -->
  <ng-container *ngTemplateOutlet="pageBodyContent" />
</glxy-nav>

<!-- Menu Content -->
<ng-template #menuContent>
  <div class="site-menu">
    <a class="galaxy-logo" routerLink="/" tabindex="-1">
      <img src="/assets/img/galaxy-logo.png" width="auto" height="42px" />
    </a>

    <ul class="site-nav">
      <li>
        <a
          class="nav-link"
          routerLinkActive="nav-link-active"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLink="/"
          >
          Home
        </a>
      </li>
      <li class="group-end">
        <a
          class="nav-link"
          href="https://vendasta.jira.com/wiki/spaces/GLXY/pages/686227458/UX+writing+guidelines"
          target="_blank"
          >
          UX writing guidelines (internal)
          <!-- we set the width manually to stop the element from expanding and contracting, thus causing a layout bug in the nav width on load -->
          <mat-icon inline style="width: 14px">open_in_new</mat-icon>
        </a>
      </li>

      @for (menuGroup of this.siteMenu; track menuGroup) {
        <li class="heading">
          <span class="heading-name">{{ menuGroup.groupName }}</span>
          <ul class="children">
            @for (link of menuGroup.links; track link) {
              <li>
                <a
                  class="nav-link"
                  [routerLink]="link.url"
                  [routerLinkActiveOptions]="navLinkActiveMatchingOptions"
                  routerLinkActive="nav-link-active"
                  >
                  {{ link.name }}
                </a>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- Page Content -->
<ng-template #pageBodyContent>
  <div class="main-toolbar">
    <button class="toggle-menu" mat-icon-button id="toolbar-menu-toggle" (click)="nav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="omni-search">
      <obs-site-search />
    </div>

    <div class="right-icons">
      <obs-color-scheme-switcher />
      <div class="open-github">
        <a
          mat-icon-button
          href="https://github.com/vendasta/galaxy/tree/master/libs/galaxy"
          class="open-in-github-link"
          target="_blank"
          rel="noopener"
          >
          <svg class="github-logo" width="24" height="24">
            <use href="assets/img/github-logo.svg#github"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div class="page-content">
    <router-outlet />
  </div>
</ng-template>
